/** Reference this link to find event key value
 * https://www.toptal.com/developers/keycode
 */

export const KEYS = {
  TAB: 'Tab',
  HOME: 'Home',
  END: 'End',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  LEFT_ARROW: 'ArrowLeft',
  RIGHT_ARROW: 'ArrowRight',
  UP_ARROW: 'ArrowUp',
  DOWN_ARROW: 'ArrowDown',
  DELETE: 'Delete'
};
